export default __webpack_public_path__ + "static/media/journey-complete.8b1f111a.gif";